/**
 * creates Referral Message object for use with messaging component
 * @param {*} app 
 * @param {*} user 
 * @returns message object
 */
export const  getMessageObject = function(app, user) {
    let messageObject = {
        recipientName : "", //name to be displayed in UI
        myPostBox : "", //url to send message to user
        theirPostBox : "", //url to send message to recipient
        myGetExistingMessages : "", //url to get existing messages
        myGetNewMessages : "", //url to get new messages
        postData : {}, //data to send via ajax when sending a message
        getData : {} //data to send via ajax when getting messages
    };
    const urlReferralID = window.location.href.split('/').pop(); //gets referral id from url
    const serviceID = $("#myds-service-name").data('service');
    
    //set data required for sending a message
    messageObject.postData = {
        service_id : serviceID,
        user : user
    }

    //set data required for getting messages
    messageObject.getData = {
        service_id : serviceID
    }

    if (user == "citizen") {

        messageObject.recipientName = $('#myds-service-name').text();

        //set required variables for sending a message
        messageObject.postData.journal_to = $('#myds-service-name').text();
        messageObject.postData.external_id = urlReferralID;
        messageObject.myPostBox = '/send-message';
        messageObject.theirPostBox = '/send-inapp-message';

        //set required variables for getting messages
        messageObject.myGetExistingMessages = '/get-existing-pds-messages';
        messageObject.myGetNewMessages = '/get-new-pds-messages';
        messageObject.getData.tag = app;

    } else { //user = "service-provider"

        messageObject.recipientName = $('#myds-referral-referee_name-value').text();

        //set required variables for sending a message
        messageObject.postData.mydex_id = $('#myds-referral-referee_name-value').data('mydexid'); //mydex_id is written to inapp dataset (required)
        messageObject.postData.mydexID = $('#myds-referral-referee_name-value').data('mydexid'); //mydexID tells back-end whose PDS to write the message to.
        messageObject.postData.journal_by = $('#myds-service-name').text();
        messageObject.postData.external_id = $("#myds-referral-title").data('referral'); //gets citizen referral id from pds_record_id stored in UI
        messageObject.myPostBox = '/send-inapp-message/' + urlReferralID;
        messageObject.theirPostBox = '/send-message/' + urlReferralID;

        //set required variables for getting messages
        messageObject.myGetExistingMessages = '/get-existing-inapp-messages/' + urlReferralID;
        messageObject.myGetNewMessages = '/get-new-inapp-messages/' + urlReferralID;
        messageObject.getData.mydex_id = $('#myds-referral-referee_name-value').data('mydexid');
        messageObject.getData.service_name = $('#myds-service-name').text();

    }

    return messageObject;
}

